import { render, staticRenderFns } from "./ExtraTable.vue?vue&type=template&id=e0beb0f8&"
import script from "./ExtraTable.vue?vue&type=script&lang=js&"
export * from "./ExtraTable.vue?vue&type=script&lang=js&"
import style0 from "./ExtraTable.vue?vue&type=style&index=0&id=e0beb0f8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports